import { FeatureBase } from '../FeatureBase'
import { Config, DeviceDataSnapshot } from '../../types/config'
// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    config: IConfigFeature
  }
}

export interface IConfigFeature {
  /** 获取当前配置 */
  getCurrentConfig(): Promise<Config>
  /** 获取当前配置索引 */
  getCurrentConfigIndex(): Promise<number>
  /** 获取当前配置名称 */
  getCurrentConfigName(index?: number): Promise<string>
  /** 获取全部配置 */
  getAllConfigs(): Promise<Config[]>
  /** 切换配置 */
  setCurrentConfig(index: number): Promise<void>
  /** 修改配置名称 */
  renameConfig(config: Config): Promise<void>
  /** 创建配置 */
  createConfig(name: string, index?: number): Promise<number>
  /** 删除配置 */
  deleteConfig(index: number): Promise<void>
  /** 初始化全部配置（恢复出厂设置）。键盘/鼠标写 flash；底座走协议恢复出厂命令。 */
  initAllConfigs(): Promise<void>
  /** 获取当前配置快照 */
  getCurrentConfigSnapshot(): Promise<DeviceDataSnapshot>
  /** 同步快照数据到当前配置 */
  setCurrentConfigSnapshot(snapshot: DeviceDataSnapshot): Promise<void>

  /** 恢复管理员设置 */
  initAllConfigsByAdmin(): Promise<void>
  /** 进入管理员模式 */
  enterAdminMode(): Promise<void>
  /** 退出管理员模式 */
  exitAdminMode(): Promise<void>
}

export class ConfigFeature extends FeatureBase implements IConfigFeature {
  /** 获取当前使用配置 */
  getCurrentConfig(): Promise<Config> {
    return this.unsupported('ConfigFeature.getCurrentConfig')
  }
  /** 获取当前使用配置索引 */
  getCurrentConfigIndex(): Promise<number> {
    return this.unsupported('ConfigFeature.getCurrentConfigIndex')
  }
  /** 获取当前使用配置名称 */
  getCurrentConfigName(_index?: number): Promise<string> {
    return this.unsupported('ConfigFeature.getCurrentConfigName')
  }
  /** 获取全部配置 */
  getAllConfigs(): Promise<Config[]> {
    return this.unsupported('ConfigFeature.getAllConfigs')
  }
  /** 切换配置 */
  setCurrentConfig(_index: number): Promise<void> {
    return this.unsupported('ConfigFeature.setCurrentConfig')
  }
  /** 修改配置名称 */
  renameConfig(_config: Config): Promise<void> {
    return this.unsupported('ConfigFeature.renameConfig')
  }
  /** 创建配置 */
  createConfig(_name: string, _index?: number): Promise<number> {
    return this.unsupported('ConfigFeature.createConfig')
  }
  /** 删除配置 */
  deleteConfig(_index: number): Promise<void> {
    return this.unsupported('ConfigFeature.deleteConfig')
  }
  /** 初始化全部配置（恢复出厂设置） */
  initAllConfigs(): Promise<void> {
    return this.unsupported('ConfigFeature.initAllConfigs')
  }
  /** 获取当前配置快照 */
  getCurrentConfigSnapshot(): Promise<DeviceDataSnapshot> {
    return this.unsupported('ConfigFeature.getCurrentConfigSnapshot')
  }
  /** 同步快照数据到当前配置 */
  setCurrentConfigSnapshot(_snapshot: DeviceDataSnapshot): Promise<void> {
    return this.unsupported('ConfigFeature.setCurrentConfigSnapshot')
  }

  /** 恢复管理员设置 */
  initAllConfigsByAdmin(): Promise<void> {
    return this.unsupported('ConfigFeature.initAllConfigsByAdmin')
  }
  /** 进入管理员模式 */
  enterAdminMode(): Promise<void> {
    return this.unsupported('ConfigFeature.enterAdminMode')
  }
  /** 退出管理员模式 */
  exitAdminMode(): Promise<void> {
    return this.unsupported('ConfigFeature.exitAdminMode')
  }
}
